/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  TextField,
  FormControl,
  InputAdornment,
  IconButton,
  Input,
  FormHelperText,
} from "@material-ui/core";
import { Field } from "formik";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { EditComponentProps } from "material-table";
import { ConnectionConfigDataRow } from "../../../../types/config";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    root: {
      fontSize: 13,
    },
    formControl: {
      minWidth: "12rem",
      width: "90%",
    },
    passwordVisibilityIconButton: {
      padding: "0.25rem",
    },
  })
);

/** 認証ユーザー名 / パスワード編集コンポーネント */
export function UsernameAndPasswordEditComponent(
  props: EditComponentProps<ConnectionConfigDataRow>
) {
  const classes = useStyles();

  const { value, onChange, columnDef } = props;

  //--------------------
  // コンポーネント
  return (
    // eslint-disable-next-line react/destructuring-assignment
    <Field name={props.columnDef.field}>
      {(args: any) => {
        const { field, form } = args;
        const { name } = field;
        const { errors, touched, setFieldValue } = form;

        // onChange, onBlur, name and value は
        // name で引き当てて HtmlのReactコンポーネントに自動注入するが、
        // このコンポーネントは２つフィールドを含む都合上設定が行われない。
        // フォーカスアウト時にはtouchedにできないが、
        // 適用ボタンを押下時にtouchedになるのでそれで良しとする。

        // フィールドエラー表示判定: 認証ユーザー名
        const showErrorUsername = () => {
          let isError = false;
          if (touched.usernameAndPassword) {
            isError = touched.usernameAndPassword.username && errors.username;
          }
          return isError;
        };

        return (
          <>
            <div>
              {/*
                認証ユーザー名

              */}
              <FormControl
                className={classes.formControl}
                error={"username" in errors}
              >
                <TextField
                  size="small"
                  placeholder="認証ユーザー名"
                  inputProps={{
                    style: { fontSize: 13 },
                  }}
                  value={value.username}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const newData = {
                      ...value,
                      username: event.target.value,
                    };
                    onChange(newData); // for MaterialTable
                    setFieldValue(name, newData); // for Formik
                  }}
                  error={showErrorUsername()}
                />
                {showErrorUsername() ? (
                  <FormHelperText>{errors.username}</FormHelperText>
                ) : null}
              </FormControl>
            </div>

            {/*
              パスワード

            */}
            <div>
              <FormControl>
                <Input
                  {...props}
                  {...field}
                  type={value.password.editVisible ? "text" : "password"}
                  className={classes.root}
                  placeholder="パスワード"
                  value={value.password.value}
                  error={touched[name] && errors[name]}
                  // helperText={errors[name] && touched[name] && errors[name]}
                  onChange={(e: any) => {
                    const newData = {
                      ...value,
                      password: {
                        value: e.target.value,
                        renderVisible: value.password.renderVisible,
                        editVisible: value.password.editVisible,
                      },
                    };
                    props.onChange(newData);
                    setFieldValue(name, newData);
                  }}
                  size="small"
                  endAdornment={(
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        className={classes.passwordVisibilityIconButton}
                        onClick={() => {
                            const newData = {
                              ...value,
                              password: {
                                value: value.password.value,
                                renderVisible: value.password.renderVisible,
                                editVisible: !value.password.editVisible, // この値だけ反転させる
                              },
                            };
                            props.onChange(newData);
                            setFieldValue(name, newData);
                          }}
                        onMouseDown={(
                            event: React.MouseEvent<HTMLButtonElement>
                          ) => {
                            event.preventDefault();
                          }}
                      >
                        {value.password.editVisible ? (
                          <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                      </IconButton>
                    </InputAdornment>
                    )}
                />
                {touched[name] && errors[name] && (
                  <FormHelperText error>
                    {touched[name] && errors[name]}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
          </>
        );
      }}
    </Field>
  );
}
